var _style, _circle, _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4CollectSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#F4A38B;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 106.7,
    cy: 106.8,
    r: 77.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.7,164.1L106.7,164.1c-7.9,0-14.4-6.4-14.4-14.4V82.1c0-7.9,6.4-14.4,14.4-14.4l0,0 c7.9,0,14.4,6.4,14.4,14.4v67.6C121.1,157.6,114.7,164.1,106.7,164.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105,134.3c0.5-0.3,1.1-0.5,1.7-0.5l0,0l0,0l0,0l0,0h0l0,0c0.6,0,1.1,0.2,1.6,0.5c0,0,0,0,0.1,0l0.1-64.8H105 L105,134.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.8,133.4L106.8,133.4L106.8,133.4c-0.3,0-0.5,0-0.8,0.1c-0.3,0.1-0.5,0.2-0.8,0.4c-0.6,0.4-1.2,0.9-1.7,1.7 c-1.1,1.4-2.1,3.5-2.7,5.4c-0.4,1.3-0.6,2.5-0.6,3.4v0l0,0c0,1.8,0.7,3.4,1.9,4.6s2.8,1.9,4.6,1.9c0,0,0,0,0,0 c1.8,0,3.4-0.7,4.6-1.9s1.9-2.8,1.9-4.6v0c0-0.6-0.1-1.3-0.2-2.1c-0.2-0.8-0.4-1.6-0.7-2.5c-0.6-1.7-1.5-3.4-2.5-4.5 c-0.7-0.8-1.4-1.4-2-1.6C107.4,133.4,107.1,133.4,106.8,133.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 52.7,
    className: "st1",
    width: 35.4,
    height: 29.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.8,123.3c0,0-0.2,0.1-0.4,0.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4CollectSample);
export default __webpack_public_path__ + "static/media/4CollectSample.dfbf0975d8996b2acd04fad38525922c.svg";
export { ForwardRef as ReactComponent };